import type { Action } from '../action'
import { ResourceType } from '../resource-type'

/**
 * Using agents. An agent may be granted tenant-wide, for a zone or for an
 * app, so a request is checked against every candidate URN — see
 * `Urn.agentCandidates`. Seeing it is `client:agent:access`
 */
export const AGENT_ACTIONS = {
  'agent:chat:invoke': {
    description: 'Chat with an agent',
    resourceTypes: [ResourceType.Agent],
  },
} as const satisfies Record<string, Action.Definition>
